import {i18n} from "../../../vue-i18n";

export default class ChangeLessors {
  constructor(changedLessorsIds) {
    this.commandName = "ChangeLessors";
    this.changedLessorsIds = changedLessorsIds;

    this.description = `${i18n.t('CONTENT.events.ChangeLessors')}`;
    this.description = '';
  }

  // Use this method to push this command to the server
  serialize() {
    const serialisedCommand = JSON.stringify({
      changedLessorsIds: this.changedLessorsIds,
    });

    return {
      commandName: this.commandName,
      serialisedCommand,
    };
  }

  equal() {
    // will always return false so user can add multiple payments
    return false;
  }
}
